var moduleMap = {
	".": () => {
		return __webpack_require__.e(1).then(() => (() => ((__webpack_require__(5)))));
	},
	"./dayjs": () => {
		return __webpack_require__.e(2).then(() => (() => ((__webpack_require__(6)))));
	},
	"./froala-editor": () => {
		return Promise.all([__webpack_require__.e(4), __webpack_require__.e(3)]).then(() => (() => ((__webpack_require__(17)))));
	},
	"@automapper/classes": () => {
		return Promise.all([__webpack_require__.e(15), __webpack_require__.e(14), __webpack_require__.e(13)]).then(() => (() => ((__webpack_require__(23)))));
	},
	"@automapper/core": () => {
		return __webpack_require__.e(15).then(() => (() => ((__webpack_require__(25)))));
	},
	"@iqx/tree-grid": () => {
		return __webpack_require__.e(16).then(() => (() => ((__webpack_require__(26)))));
	},
	"@reduxjs/toolkit": () => {
		return Promise.all([__webpack_require__.e(18), __webpack_require__.e(17)]).then(() => (() => ((__webpack_require__(27)))));
	},
	"@tanstack/react-query": () => {
		return __webpack_require__.e(7).then(() => (() => ((__webpack_require__(33)))));
	},
	"axios": () => {
		return __webpack_require__.e(22).then(() => (() => ((__webpack_require__(36)))));
	},
	"class-validator": () => {
		return __webpack_require__.e(23).then(() => (() => ((__webpack_require__(37)))));
	},
	"dompurify": () => {
		return __webpack_require__.e(24).then(() => (() => ((__webpack_require__(144)))));
	},
	"downloadjs": () => {
		return __webpack_require__.e(25).then(() => (() => ((__webpack_require__(145)))));
	},
	"highcharts": () => {
		return __webpack_require__.e(26).then(() => (() => ((__webpack_require__(146)))));
	},
	"highcharts-react-official": () => {
		return __webpack_require__.e(8).then(() => (() => ((__webpack_require__(147)))));
	},
	"i18next": () => {
		return __webpack_require__.e(19).then(() => (() => ((__webpack_require__(148)))));
	},
	"immer": () => {
		return __webpack_require__.e(20).then(() => (() => ((__webpack_require__(32)))));
	},
	"inversify": () => {
		return __webpack_require__.e(27).then(() => (() => ((__webpack_require__(149)))));
	},
	"lodash": () => {
		return __webpack_require__.e(28).then(() => (() => ((__webpack_require__(150)))));
	},
	"mitt": () => {
		return __webpack_require__.e(29).then(() => (() => ((__webpack_require__(151)))));
	},
	"react": () => {
		return __webpack_require__.e(5).then(() => (() => ((__webpack_require__(20)))));
	},
	"react-dom": () => {
		return __webpack_require__.e(9).then(() => (() => ((__webpack_require__(152)))));
	},
	"react-redux": () => {
		return Promise.all([__webpack_require__.e(9), __webpack_require__.e(21)]).then(() => (() => ((__webpack_require__(156)))));
	},
	"react-router": () => {
		return Promise.all([__webpack_require__.e(32), __webpack_require__.e(6)]).then(() => (() => ((__webpack_require__(166)))));
	},
	"react-router-dom": () => {
		return Promise.all([__webpack_require__.e(9), __webpack_require__.e(32), __webpack_require__.e(33)]).then(() => (() => ((__webpack_require__(168)))));
	},
	"react-use": () => {
		return __webpack_require__.e(11).then(() => (() => ((__webpack_require__(169)))));
	},
	"redux-persist": () => {
		return Promise.all([__webpack_require__.e(18), __webpack_require__.e(34)]).then(() => (() => ((__webpack_require__(189)))));
	},
	"redux-saga": () => {
		return Promise.all([__webpack_require__.e(30), __webpack_require__.e(31)]).then(() => (() => ((__webpack_require__(190)))));
	},
	"reflect-metadata": () => {
		return __webpack_require__.e(14).then(() => (() => ((__webpack_require__(24)))));
	},
	"short-uuid": () => {
		return __webpack_require__.e(35).then(() => (() => ((__webpack_require__(194)))));
	},
	"single-spa": () => {
		return __webpack_require__.e(36).then(() => (() => ((__webpack_require__(198)))));
	},
	"styled-components": () => {
		return __webpack_require__.e(10).then(() => (() => ((__webpack_require__(199)))));
	},
	"typed-redux-saga": () => {
		return Promise.all([__webpack_require__.e(30), __webpack_require__.e(37)]).then(() => (() => ((__webpack_require__(201)))));
	},
	"react-dom/server": () => {
		return __webpack_require__.e(12).then(() => (() => ((__webpack_require__(202)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});